import React, { useEffect } from "react";
import Helmet from "react-helmet";
import { useSiteMetadata } from "../../hooks/use-site-metadata";

import Footer from "../Footer/index.js";
import Header from "../Header/index.js";

import GlobalStyle from "../../styles/GlobalStyle";
import { Wapper } from "./styles";

const Layout = ({ children }) => {
  const data = useSiteMetadata();
  useEffect(() => {
    const focusWrapper = document.getElementById("gatsby-focus-wrapper");
    if (focusWrapper) {
      focusWrapper.removeAttribute("tabindex"); // Or set to a different value
    }
  }, []);

  return (
    <div>
      <GlobalStyle />
      <Helmet title={data.site.siteMetadata.title}>
        <html lang="en" />
      </Helmet>
      <Header siteTitle={data.site.siteMetadata.title} />
      <Wapper>{children}</Wapper>
      <Footer />
    </div>
  );
};

export default Layout;
